import React from 'react'

import { useQuery } from '../hooks/useQuery'

const withTuition = BaseComponent => props => {
  const tuitionOperation = 'universityTuition'
  const defaultTuitionVariables = {
    university: { value: '', type: 'String', required: true },
  }

  const salaryByJobTitleOperation = 'salaryByJobTitle'
  const defaultSalaryByJobTitleVariables = {
    jobTitle: { value: '', type: 'String', required: true },
  }

  const {
    data: salaryByJobTitleData,
    loading: loadingSalaryByJobTitle,
    refetch: getSalaryByJobTitle,
  } = useQuery(salaryByJobTitleOperation, defaultSalaryByJobTitleVariables, { lazy: true })

  const { data: tuitionData, refetch: getTuitionData, loading: loadingTuitionData } = useQuery(
    tuitionOperation,
    defaultTuitionVariables,
    {
      lazy: true,
    },
  )

  const getTuition = params => {
    getTuitionData(params)
  }

  const universityData = tuitionData ? tuitionData : {}
  const salaryByJobTitle = Math.round(salaryByJobTitleData)

  return (
    <BaseComponent
      {...props}
      universityData={universityData}
      getTuitionData={getTuition}
      loadingTuitionData={loadingTuitionData}
      salaryByJobTitle={salaryByJobTitle}
      loadingSalaryByJobTitle={loadingSalaryByJobTitle}
      getSalaryByJobTitle={getSalaryByJobTitle}
    />
  )
}

export default withTuition



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withTuition.js